
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 .436C5.624.436.436 5.624.436 12S5.624 23.564 12 23.564 23.564 18.376 23.564 12 18.376.436 12 .436zm0 21.819c-5.654 0-10.255-4.6-10.255-10.255 0-5.654 4.6-10.255 10.255-10.255 5.654 0 10.255 4.6 10.255 10.255 0 5.654-4.6 10.255-10.255 10.255zm0-16.146A5.898 5.898 0 006.11 12a.655.655 0 01-1.31 0c0-3.97 3.23-7.2 7.2-7.2 1.07 0 2.1.23 3.062.682a.655.655 0 01-.556 1.185A5.853 5.853 0 0012 6.109zm6.16 1.83a.655.655 0 01.04.925l-4.633 5.061a2.182 2.182 0 11-.96-.89l4.63-5.056a.656.656 0 01.923-.04z","fill":"#FFF","fill-rule":"nonzero"}})])
          )
        }
      }
    